import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApplicationDataService } from './application.service';
import { environment } from '../environments/environment';

/**
 * Calls the TriPOD passthrough that proxies the TriCore survey-metadata
 * endpoint (TP-9216). The response shape is owned by that endpoint and is
 * written verbatim into the Medallia application survey cookie by
 * `SurveyCookieService`.
 */
@Injectable({ providedIn: 'root' })
export class SurveyMetadataService {
  private static readonly API_ENDPOINT = environment.apiEndPoint;

  constructor(
    private http: HttpClient,
    private applicationService: ApplicationDataService) { }

  getApplicationSurveyMetadata(rentalApplicationKey: string): Observable<unknown> {
    const url = `${SurveyMetadataService.API_ENDPOINT}rental-applications/${encodeURIComponent(rentalApplicationKey)}/survey-metadata`;
    return this.http.get<unknown>(url, this.applicationService.createOptions());
  }
}
